<template>
  <div class="sticky_row">
    <div class="native-scrollbar" id="nativeScrollbar" aria-hidden="true" :data-table-id="tableId">
      <div class="native-scrollbar-inner"></div>
    </div>
    <div class="action_line fixed_line">
        <p class="check_all" v-if="multipleActionOptions">
            <input v-if="!disableSelectAll" id="check-all-bottom" type="checkbox" v-model="toggleSelectAll">
            <label v-if="!disableSelectAll" for="check-all-bottom" v-translate>Vybrat vše</label>
            <select id="akce" name="akce" v-model="selectedMultipleAction">
                <option v-for="option in multipleActionOptions" :value="option.value">
                    {{ option.text }}
                </option>
            </select>
            <input class="btn" type="submit" :value="'Provést' | translate" @click.prevent="emitMultipleAction">
        </p>

        <input type="submit" v-if="showSubmitButton" :value="'Uložit' | translate"
               :class="['btn', 'save', { btn_inactive: !isFormValid }]"
               @click.prevent.stop="emitSubmitForm()" :disabled="!isFormValid">

        <pagination
                :limit="limit"
                :offset="offset"
                :total-count="totalCount"
                @limit="emitLimit"
                @offset="emitOffset"
        ></pagination>
    </div>
  </div>
</template>

<script>
	import Pagination from "@/components/common/Pagination"

	export default {
		name: "ListActionLine",
		components: {Pagination},
		data: () => {
			return {
				selectedMultipleAction: 'choose'
			}
		},
		props: {
      tableId: String,
			paginationId: {
				type: String,
				default: 'pagination'
			},
			showSubmitButton: Boolean,
			isFormValid: Boolean,
			entities: Array,
			selectedEntities: {
				type: Array,
				default: () => {
					return []
				},
			},
			multipleActionOptions: Array,
			limit: [String, Number],
			offset: Number,
			totalCount: Number,
      disableSelectAll: Boolean,
		},
		computed: {
			toggleSelectAll: {
				get() {
          if(!this.entities){
            return false;
          }
          for(const entity of this.entities){
            if(!this.selectedEntities.includes(String(entity.id))){
              return false;
            }
          }
          return true;
				},
				set(value) {
					this.$emit('select-all', value)
				}
			}
		},
		methods: {
			emitOffset(value) {
				this.$emit('offset', value)
			},
			emitMultipleAction() {
				this.$emit('run-multiple-action', this.selectedMultipleAction)
			},
			emitSubmitForm() {
				this.$emit('submit-form')
			},
      emitLimit(limit) {
        this.$emit('limit', limit)
      }
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/common/ListActionLine.vue